<!-- Register route: path: '/org/:sub_level/:id/proface-wing-intro', component: ProfaceWingIntro -->
<template>
    <div class="section pt-2">
        <div class="grq-hero">
            <div class="grq-hero-icon"><ion-icon name="people-outline"></ion-icon></div>
            <h3 class="grq-hero-title mal-text">PROFACE COMMUNE</h3>
            <p class="grq-hero-desc mal-text">PROFESSIONAL WING, WISDOM YOUTH</p>
        </div>
    </div>

    <div class="section mt-1">
        <a href="javascript:void(0)" class="grq-option-card" @click="openFormModal">
            <div class="grq-option-icon grq-option-icon--new"><ion-icon name="create-outline"></ion-icon></div>
            <div class="grq-option-body">
                <div class="grq-option-title mal-text">ഫോം</div>
                <div class="grq-option-desc mal-text">മണ്ഡലം കമ്മറ്റി വിവരങ്ങൾ ചേർക്കുക / തിരുത്തുക</div>
            </div>
            <ion-icon name="chevron-forward-outline" class="grq-option-chevron"></ion-icon>
        </a>

        <router-link :to="listPath" class="grq-option-card">
            <div class="grq-option-icon grq-option-icon--list"><ion-icon name="list-outline"></ion-icon></div>
            <div class="grq-option-body">
                <div class="grq-option-title mal-text">ലിസ്റ്റ്</div>
                <div class="grq-option-desc mal-text">സമർപ്പിച്ച കമ്മറ്റി വിവരങ്ങൾ കാണുക</div>
            </div>
            <ion-icon name="chevron-forward-outline" class="grq-option-chevron"></ion-icon>
        </router-link>
    </div>

    <!-- Form bottom sheet -->
    <div class="modal fade action-sheet" id="profaceWingFormModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title mal-text">PROFACE COMMUNE ഫോം</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <ProfaceWingForm embedded @submitted="onFormSubmitted" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import ProfaceWingForm from "./ProfaceWingForm.vue";

export default {
    name: "ProfaceWingIntro",
    components: { ProfaceWingForm },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        listPath() {
            return "/org/" + this.$route.params.sub_level + "/" + this.$route.params.id + "/proface-wing-report";
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace("/");
            return;
        }
        this.$root.updateParent("PROFACE COMMUNE");
    },
    methods: {
        openFormModal() {
            $("#profaceWingFormModal").modal("show");
        },
        closeFormModal() {
            $("#profaceWingFormModal").modal("hide");
        },
        onFormSubmitted() {
            this.closeFormModal();
        },
    },
};
</script>

<style scoped>
.grq-hero {
    background: #fff;
    border-radius: 14px;
    padding: 22px 18px;
    text-align: center;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.grq-hero-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: #eef2ff;
    color: #1a418c;
    font-size: 26px;
    margin-bottom: 10px;
}

.grq-hero-title {
    font-size: 1.05rem;
    font-weight: 700;
    color: #27173E;
    margin-bottom: 6px;
}

.grq-hero-desc {
    font-size: 0.85rem;
    color: #6c757d;
    line-height: 1.5;
    margin: 0;
}

.grq-option-card {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    margin-bottom: 10px;
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    text-decoration: none;
    transition: background-color 0.15s ease;
}

.grq-option-card:active {
    background: #f8f9fa;
}

.grq-option-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    font-size: 22px;
}

.grq-option-icon--new {
    background: #eef2ff;
    color: #1a418c;
}

.grq-option-icon--list {
    background: #f0fdf4;
    color: #12a85a;
}

.grq-option-body {
    flex: 1;
    min-width: 0;
}

.grq-option-title {
    font-size: 0.95rem;
    font-weight: 700;
    color: #27173E;
    margin-bottom: 2px;
}

.grq-option-desc {
    font-size: 0.78rem;
    color: #6c757d;
    line-height: 1.4;
}

.grq-option-chevron {
    flex-shrink: 0;
    font-size: 20px;
    color: #adb5bd;
}
</style>
